export default function px(value) {
    return `${value}px`
}